module.exports = __webpack_public_path__ + "static/media/03-1-galeria-01-pronovias-mobile@2x.a67fb245.jpg";